import { trackById } from 'src/app/shared/utils/track-by.util';
import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SEG } from 'src/app/models/seg.model';
import { ErrorConstants } from 'src/app/shared/constants/error.constants';

@Component({
  standalone: false,
  selector: 'app-group-associated-segs',
  templateUrl: './group-associated-segs.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./group-associated-segs.component.scss']
})
export class GroupAssociatedSegsComponent implements OnInit {
  @Input() exposureAllSEGs: SEG[];
  @Input() loadingAllSEGs: boolean = true;

  errorMessage: string = "";

  constructor(
  ) {
    this.errorMessage = ErrorConstants.errorMessage;
  }

  ngOnInit(): void {
  }

  public trackById = trackById;
}
